import React from 'react'
import { useAppInsightsContext, useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { Button } from 'antd'
import { eventTypes } from './eventTypes'
import './ButtonAnalyticsAntd.scss'

interface Props {
  buttonType?: 'primary' | 'dashed' | 'icon'
  [key: string]: any
}

const ButtonAnalyticsAntd = (props: Props) => {
  const appInsights = useAppInsightsContext()
  const trackButtonClick = useTrackEvent(appInsights, eventTypes.button_clicked, {})

  const { keyAnalytics, buttonType, ...rest } = props
  const onButtonAnalyticsClick = () => {
    // Fire analytics without awaiting so the click stays inside the synchronous
    // user-gesture context — otherwise browsers block window.open() popups.
    trackButtonClick({ key: keyAnalytics, text: props.children })

    props.onClick?.()
  }

  return (
    <Button className={buttonType || 'default'} {...rest} onClick={onButtonAnalyticsClick}></Button>
  )
}

export default ButtonAnalyticsAntd
